const GET_REGISTER_USER = 'GET_REGISTER_USER';
const GET_REGISTER_USER_SUCCESS = 'GET_REGISTER_USER_SUCCESS';
const GET_REGISTER_USER_ERROR = 'GET_REGISTER_USER_ERROR';
export {
  GET_REGISTER_USER, GET_REGISTER_USER_SUCCESS, GET_REGISTER_USER_ERROR
};
